import { Combobox } from "@/components/ui/Combobox";
import { City, type ICity } from "country-state-city";
import { useMemo } from "react";

interface Props {
  placeholder?: string;
  onValueChange: ({ value, label }: { value: string; label: string }) => void;
  value?: string;
  countryCode: string;
  stateCode: string;
}

export const CityCombobox = (props: Props): JSX.Element => {
  const cities = useMemo(() => {
    return City.getCitiesOfState(props.countryCode, props.stateCode).map(
      (city: ICity) => ({ label: city.name, value: city.name })
    );
  }, [props.countryCode, props.stateCode]);

  return (
    <Combobox
      items={cities}
      placeholder={props.placeholder}
      value={props.value}
      onValueChange={(value) => {
        props.onValueChange({ label: value.label, value: value.value });
      }}
    />
  );
};
